var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88135 8.45711L16.7696 1.56216C16.8911 1.44004 16.9593 1.27473 16.9591 1.10245C16.959 0.93017 16.8906 0.764956 16.769 0.642995C16.5254 0.400659 16.0964 0.399436 15.8504 0.64422L8.96402 7.53917L2.07519 0.642384C1.8304 0.400659 1.40142 0.401883 1.15786 0.643607C1.09741 0.70382 1.04955 0.775471 1.01708 0.854377C0.984617 0.933284 0.968191 1.01787 0.968765 1.10319C0.968765 1.27699 1.03608 1.43977 1.15786 1.56032L8.04608 8.4565L1.15847 15.3533C1.03693 15.4756 0.968862 15.6411 0.969206 15.8136C0.96955 15.986 1.03828 16.1512 1.16031 16.2731C1.27842 16.3899 1.44548 16.4573 1.61805 16.4573H1.62173C1.79491 16.4567 1.96198 16.3887 2.07764 16.2706L8.96402 9.37566L15.8529 16.2725C15.9746 16.3936 16.1374 16.4609 16.31 16.4609C16.3953 16.4612 16.4799 16.4445 16.5587 16.412C16.6376 16.3795 16.7093 16.3316 16.7696 16.2713C16.83 16.211 16.8778 16.1393 16.9103 16.0604C16.9429 15.9815 16.9595 15.897 16.9593 15.8116C16.9593 15.6385 16.892 15.4751 16.7696 15.3545L9.88135 8.45711Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteX);
export default __webpack_public_path__ + "static/media/deleteX.9743a7b0c0547c4e3ffaa17403c31f2d.svg";
export { ForwardRef as ReactComponent };